// =============================================================================
// STRIPE PAYMENT LINKS
// =============================================================================
// Generated by dev/create-payment-links.mjs — the 25% platform commission
// is baked into every connected trainer's link, and 0% for in-house Igor.
//
// Never put a secret key (sk_...) in this file. These public buy.stripe.com
// URLs are the only Stripe values that belong in the website.
// =============================================================================

export const trainerSubscribeLinks = {
  "tina-pecaver": "https://buy.stripe.com/3cI3cweoz5FV5WWaHxdIA00",
  "matej-krestic": "https://buy.stripe.com/28E6oIafZ0fM5gqemg1RC00",
  "jurij-spanja": "https://buy.stripe.com/9B68wQ6UU4Bt2sh7cQd7q00",
  "igor-martic": "https://buy.stripe.com/aFacN6dtC31qa944U74F204", // in-house, no fee
  "katrin-don": "https://buy.stripe.com/dRm3cwerL9tS6rt2G16kg00",
  "luka-golob": "https://buy.stripe.com/bJe8wR4BZ73JaD89Zg73G00",
};

export const programLinks = {
  // Tina Pečaver
  1: "https://buy.stripe.com/00w4gAeozfgv710aHxdIA01", // Booty & Core Builder
  2: "https://buy.stripe.com/fZu28sgwHfgvgBAcPFdIA02", // Fit Cookbook
  3: "https://buy.stripe.com/9B67sM80bd8n2KKbLBdIA03", // Hyrox Start
  19: "https://buy.stripe.com/4gM4gAa8j2tJetsbLBdIA04", // HIIT (content TODO)

  // Matej Kreštić
  4: "https://buy.stripe.com/4gM4gAbk39QmgZ891W1RC01", // Beginner Builder
  5: "https://buy.stripe.com/9B68wQ4VF4w28sCba41RC02", // Booty Builder
  6: "https://buy.stripe.com/5kQ3cw5ZJfaG38i1zu1RC03", // HIIT
  7: "https://buy.stripe.com/28E6oIafZ4w210ace81RC04", // Pro Builder

  // Jurij Španja
  8: "https://buy.stripe.com/aFafZi1AAgkb9UJ0Osd7q01", // Arms & Shoulders
  9: "https://buy.stripe.com/9B6fZicfe6JB2shfJmd7q02", // Beginner Strength
  10: "https://buy.stripe.com/3cIeVea762tl2shgNqd7q03", // Funkcionalni Bodybuilding
  11: "https://buy.stripe.com/8x2fZibbac3V9UJcxad7q04", // Mobility & Stretching

  // Igor Martić (in-house, no fee)
  12: "https://buy.stripe.com/00wdRa61a6dC80Waer4F205", // Fit & Fabulous: Gentle Start
  13: "https://buy.stripe.com/bJe14oahqfOc95086j4F206", // Fit & Fabulous: Elevated
  14: "https://buy.stripe.com/fZucN6cpy45u80WfyL4F207", // Fit & Fabulous: Unstoppable

  // Katrin Don
  15: "https://buy.stripe.com/bJe5kE0AV0Xm2bd3K56kg01", // Pilates Intermediate
  16: "https://buy.stripe.com/fZu6oIerL6hG6rtdkF6kg02", // Runner's Knee Rehab
  20: "https://buy.stripe.com/8x2cN6cjDdK8g23gwR6kg03", // Fitnes za začetnike (content TODO)

  // Luka Golob
  17: "https://buy.stripe.com/9B6bJ39Wj5ZFh1wfjA73G01", // Squat Program
  18: "https://buy.stripe.com/7sY28t7ObgEjh1w7R873G02", // Tips & Tricks
  21: "https://buy.stripe.com/4gM6oJgkHbjZ7qWc7o73G03", // Hyrox (content TODO)
  22: "https://buy.stripe.com/9B67sNfgDafV5iOb3k73G04", // Crossfit (content TODO)
};

// Small helper: true only when a real Stripe link has been pasted in.
export function hasStripeLink(url) {
  return typeof url === "string" && url.startsWith("https://");
}
